import React from 'react';
import TableColumnTitle from '../../../../../components/_table/TableColumnTitle';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import TableFilterInput from '../../../../../components/_table/TableFilterInput';
import Tag from '../../../../../components/tag/Tag';
import Button from '../../../../../components/Button';
import Anchor from '../../../../../components/link/Anchor';
import OpenPreviewTagDetail from '../../../../../containers/app/common/OpenPreviewTagDetail';
import { TAG_HISTORY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { TAG_STATUS_V2_TEXT } from '../../../../../constants/service/app/tagConstants';
import { openNewWindow, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  후기 태그 컬럼
 */
export const columns = (data) => {
  const { filterOption, onFilter, isFilter, sortOption, onClickRelatedTagList } = data;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'tagAttachments',
      className: !isFilter && 'not-filter',
      render: (value) => {
        return <TableColumnImg url={value[0]?.url || null} width={'60px'} height={'60px'} />;
      },
    },
    {
      title: <TableColumnTitle title={'태그 ID'} filterValue={filterOption.id} />,
      dataIndex: 'id',
      className: !isFilter && 'not-filter',
      sortOrder: sortOption && sortOption.id === 'id' ? 'ascend' : 'descend',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder="태그 ID 검색"
          option={filterOption.id}
          confirm={confirm}
          onFilter={(id) => onFilter({ id })}
        />
      ),
      render: (value) => (
        <Anchor
          text={value}
          isUnderLine
          color="primary"
          onClick={() => openNewWindow(setDetailPageUrl(TAG_HISTORY_URL_PATH, value))}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'태그명'} filterValue={filterOption.name} />,
      dataIndex: 'name',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput placeholder={'태그명 검색'} confirm={confirm} onFilter={(name) => onFilter({ name })} />
      ),
      render: (value, record) => <OpenPreviewTagDetail text={value} tagId={record.id} />,
    },
    {
      title: <TableColumnTitle title={'태그 상태'} />,
      dataIndex: 'status',
      render: (value) => TAG_STATUS_V2_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'태그 그룹'} />,
      dataIndex: 'tagGroups',
      render: (value) =>
        value && value.length ? value.map((item) => <Tag key={item.id} text={item.name} isAddHash={false} />) : '-',
    },
    {
      title: <TableColumnTitle title={'연관된 태그'} />,
      dataIndex: 'viewTag',
      render: (value, record) => (
        <Button
          type="button"
          isRadius
          color="primary"
          text="태그 보기"
          onClick={() => {
            onClickRelatedTagList(record.id);
          }}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
  ];
};
